// extracted by mini-css-extract-plugin
export default {"size":"40px","image":"Ga07b06","placeholder":"Gb5f3a2"};